import React from "react";
import {
  Input,
  Select,
  Button,
  Space,
  DatePicker,
  Row,
  Col,
  Dropdown,
  Checkbox,
  Modal,
  Tooltip,
  Image,
  Table,
} from "antd";
import Cookies from "js-cookie";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { decode as base64_decode } from "base-64";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import PassengerLogReportStore from "../store/PassengerLogReportStore";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);
const { Option } = Select;
class PassengerLogReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleStudentTableChange = this.handleStudentTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.passengerLogReportStore = new PassengerLogReportStore();
    this.vehicleStore = new VehicleStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      // fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      // toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      selectedVehicles: [],
      selectAllVehicles: false,

      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notasset: false,
      showMonthPopup: false,
      passengerStatus: null,
      searchStudent: "",
      dateWiseReport: false,
      monthWiseReport: false,
      fromDate: "",
      toDate: "",
      fromDateObj: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDateObj: dayjs().format("YYYY-MM-DD 23:59:59"),
      monthRange: [dayjs().startOf("month"), dayjs().endOf("month")],
      reportType: null,
      loadedStudentsData: {},
      pickupFilter: "All",
      studentPageSize: 10,
      studentCurrentPage: 1,
      selectedColumns: [
        {
          title: context.translate("_STUDENT_NAME_"),
          dataIndex: "spName",
          key: "spName",
          width: 100,
          ellipsis: { showTitle: true },
          render: (studentName) => (
            <Tooltip placement="topLeft" title={studentName}>
              {studentName}
            </Tooltip>
          ),
        },
        {
          title: context.translate("_PASSENGER_TAGID_"),
          dataIndex: "spTagId",
          key: "spTagId",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FROM_DATE_"),
          dataIndex: "fromDate",
          key: "fromDate",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_TO_DATE_"),
          dataIndex: "toDate",
          key: "toDate",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_NO_OF_DAYS_SERVICE_USED_"),
          dataIndex: "totalDaysUsed",
          key: "totalDaysUsed",
          width: 100,
          ellipsis: { showTitle: true },
        },
      ]
      // selectedColumns: [
      //   {
      //     // title: "Vehicle No",
      //     title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
      //     dataIndex: "vehicleNo",
      //     key: "vehicleNo",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //     render: (vehicleNo) => (
      //       <Tooltip placement="topLeft" title={vehicleNo}>
      //         {vehicleNo}
      //       </Tooltip>
      //     ),
      //   },
      //   {
      //     // title: "Passenger TagId",
      //     title: context.translate("_PASSENGER_TAGID_"),
      //     dataIndex: "spTagId",
      //     key: "passengertagid",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //   },

      //   {
      //     // title: "Passenger Name",
      //     title: context.translate("_PASSENGER_NAME_"),
      //     dataIndex: "spName",
      //     key: "passengername",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //   },
      //   {
      //     // title: "Login Location",
      //     title: context.translate("_LOGIN_LOCATION_"),
      //     dataIndex: "spInLocation",
      //     key: "loginLocation",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //   },
      //   {
      //     // title: "Log Out Location",
      //     title: context.translate("_LOGOUT_LOCATION_"),
      //     dataIndex: "spOutLocation",
      //     key: "logoutlocation",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //   },
      //   {
      //     // title: "Login Time",
      //     title: context.translate("_LOGIN_TIME_"),
      //     dataIndex: "spInTime",
      //     key: "logintime",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //     render: (value) => {
      //       if (value) {
      //         const formattedDateTime = dayjs(value).format(
      //           "DD-MM-YYYY hh:mm:ss A"
      //         );
      //         return <>{formattedDateTime}</>;
      //       }
      //     },
      //   },
      //   {
      //     // title: "Logout Time",
      //     title: context.translate("_LOGOUT_TIME_"),
      //     dataIndex: "spOutTime",
      //     key: "logouttime",
      //     width: 100,
      //     ellipsis: { showTitle: true },

      //     render: (value) => {
      //       if (value) {
      //         const formattedDateTime = dayjs(value).format(
      //           "DD-MM-YYYY hh:mm:ss A"
      //         );
      //         return <>{formattedDateTime}</>;
      //       }
      //     },
      //   },
      //   {
      //     // title: "Status",
      //     title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
      //     dataIndex: "inOutStatus",
      //     key: "status",
      //     width: 100,
      //     ellipsis: { showTitle: true },
      //   },
      // ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            intervel: this.state.intervel,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            PickDrop: "All",
            // userId: 1,
            filter: this.state.filter,
            searchStudent: this.state.searchStudent,
            colList: result.toString(),
          };
          if (val.key === "excel") {
            this.passengerLogReportStore.exportExcel(getData);
          }
          if (val.key === "pdf") {
            this.passengerLogReportStore.exportpdf(getData);
          }
          // if (val.key === "csv") {
          //   this.passengerLogReportStore.exportcsv(getData);
          // }
          // if (val.key === "xml") {
          //   this.passengerLogReportStore.exportxml(getData);
          // }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.showData();
  }



  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });
    await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    //  await this.handleSearch();
    await this.setState({ listUpdated: 1 });
  }

  async handleSearch() {
    this.setState({ loading: true });
    this.setState({ Notasset: false });
    await this.passengerLogReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0]?.format(format),
        toDate: dates[1]?.format(format),
      });
    }
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  showData = async () => {
    if (!this.state.reportType) {
      this.setState({ Nottype: true });
    } else {
      this.setState({ Nottype: false });
    }
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0 && this.state.reportType) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.passengerLogReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
          searchStudent: this.state.searchStudent,
          reportType: this.state.reportType,
          pickupFilter: this.state.pickupFilter
        });
        this.setState({ loading: false });
      }
    }
  };

  handleSearchStudent = async (val) => {
    await this.passengerLogReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      pageNo: this.state.currentPage,
      searchStudent: val,
      reportType: this.state.reportType,
      pickupFilter: this.state.pickupFilter
    });
    this.setState({ loading: false });
  }
  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  selectTypeofDate = (value) => {

    // 👉 WEEKLY (Sunday → Saturday)
    if (value === "2") {
      const today = dayjs();

      const startOfWeek = today.startOf("week"); // Sunday
      const endOfWeek = today.endOf("week");     // Saturday

      this.setState({
        dateWiseReport: true,
        monthWiseReport: false,
        reportType: value,
        fromDateObj: startOfWeek,
        toDateObj: endOfWeek,
        fromDate: startOfWeek.format("YYYY-MM-DD"),
        toDate: endOfWeek.format("YYYY-MM-DD"),
      });
    }

    // 👉 DATEWISE (only today)
    if (value === "3") {
      const today = dayjs();

      this.setState({
        dateWiseReport: true,
        monthWiseReport: false,
        reportType: value,
        fromDateObj: today,
        toDateObj: today,
        fromDate: today.format("YYYY-MM-DD"),
        toDate: today.format("YYYY-MM-DD"),
      });
    }

    // 👉 MONTHLY (1st → last day of month)
    if (value === "1") {
      const start = dayjs().startOf("month");
      const end = dayjs().endOf("month");

      this.setState({
        monthWiseReport: true,
        dateWiseReport: false,
        reportType: value,
        monthRange: [start, end],
        fromDate: start.format("YYYY-MM-DD"),
        toDate: end.format("YYYY-MM-DD"),
      });
    }
  };
  onExpand = async (expanded, record) => {
    const expandedRowKeys = expanded ? [record.passengerId] : [];
    this.setState({ expandedRowKeys });

    if (expanded) {
      await this.handleExpandRow(record);
    } else {
      // 🔥 Reset so it can reload next time
      this.setState((prevState) => {
        const updated = { ...prevState.loadedStudentsData };
        delete updated[record.passengerId];
        return { loadedStudentsData: updated };
      });
    }
  };

  handleExpandRow = async (record) => {
    const data = await this.passengerLogReportStore.loadStudentsData({
      passengerId: record.passengerId,
      fromDate: record.fromDate,
      toDate: record.toDate,
    });

    this.setState((prevState) => ({
      studentsDataMap: {
        ...prevState.studentsDataMap,
        [record.passengerId]: data,
      },
    }));
  };

  async handleStudentTableChange(pagination, filters, sorter) {
    const { expandedRowKeys } = this.state;
    const passengerId = expandedRowKeys[0];

    const record = this.props.dataSource.find(
      (item) => item.passengerId === passengerId
    );
    await this.setState({
      studentCurrentPage: pagination.current,
      studentPageSize: pagination.pageSize,
    });
    await this.handleChangeStudentTable(record);
  }

  handleChangeStudentTable = async (record) => {
    const data = record || this.state.expandedRowData;
    console.log(this.state.expandedRowData, "this.state.expandedRowData")
    await this.passengerLogReportStore.loadStudentsData({
      passengerId: data.passengerId,
      fromDate: data.fromDate,
      toDate: data.toDate,
      offset: (this.state.studentCurrentPage - 1) * this.state.studentPageSize,
      limit: this.state.studentPageSize
    });
    this.setState({ loadData: 1 })
  }
  // handleExpandRow = async (record) => {
  //   if (!this.state.loadedStudentsData[record.passengerId]) {
  //     await this.passengerLogReportStore.loadStudentsData({
  //       passengerId: record.passengerId,
  //       fromDate: record.fromDate,
  //       toDate: record.toDate,
  //     });
  //     // await this.setState({ expandedRowData: record })
  //     // await this.handleChangeStudentTable(record)
  //     this.setState((prevState) => ({
  //       loadedStudentsData: {
  //         ...prevState.loadedStudentsData,
  //         [record.passengerId]: true,
  //       },
  //     }));
  //   }
  // };


  getExpandedColumns = () => {
    const allColumns = [
      {
        // title: "Vehicle No",
        title: this.context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: 100,
        ellipsis: { showTitle: true },
        render: (vehicleNo) => (
          <Tooltip placement="topLeft" title={vehicleNo}>
            {vehicleNo}
          </Tooltip>
        ),
      },
      {
        // title: "Passenger TagId",
        title: this.context.translate("Trip Type"),
        dataIndex: "tripType",
        key: "tripType",
        width: 100,
        ellipsis: { showTitle: true },
      },

      {
        // title: "Passenger TagId",
        title: this.context.translate("Tag Type"),
        dataIndex: "tagType",
        key: "tagType",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Passenger Name",
        title: this.context.translate("_PASSENGER_NAME_"),
        dataIndex: "spName",
        key: "passengername",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Login Location",
        title: this.context.translate("_LOGIN_LOCATION_"),
        dataIndex: "spInLocation",
        key: "loginLocation",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Log Out Location",
        title: this.context.translate("_LOGOUT_LOCATION_"),
        dataIndex: "spOutLocation",
        key: "logoutlocation",
        width: 100,
        ellipsis: { showTitle: true },
      },
      {
        // title: "Login Time",
        title: this.context.translate("_LOGIN_TIME_"),
        dataIndex: "spInTime",
        key: "logintime",
        width: 100,
        ellipsis: { showTitle: true },
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          }
        },
      },
      {
        // title: "Logout Time",
        title: this.context.translate("_LOGOUT_TIME_"),
        dataIndex: "spOutTime",
        key: "logouttime",
        width: 100,
        ellipsis: { showTitle: true },

        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          }
        },
      },
      {
        // title: "Status",
        title: this.context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "inOutStatus",
        key: "status",
        width: 100,
        ellipsis: { showTitle: true },
      },
    ]

    return allColumns

  };

  expandedRowRender = (record) => {

    const columns = this.getExpandedColumns();
    return (
      <div className="innerGridTbl">
        <Table
          bordered
          size="small"
          // rowKey={(row) => `${record.row_id}_${row.inTime}`} // safe unique key
          style={{ padding: "20px 20px 20px 10px" }}
          columns={columns}
          dataSource={this.passengerLogReportStore.studentsData || []}
          pagination={false}
          loading={this.passengerLogReportStore?.loading}
        // onChange={this.handleStudentTableChange}
        // // current={this.state.currentPage}
        // // pageSize={this.state.studentPageSize}
        // // total={this.passengerLogReportStore?.studentDataTotal}
        // pagination={

        //   {
        //     current: this.state.studentCurrentPage,
        //     pageSize: this.state.studentPageSize,
        //     total: this.passengerLogReportStore?.studentDataTotal,
        //     // showSizeChanger: this.props.showSizeChanger,

        //   }

        // }
        />
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />

                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}

                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });

                    await this.handleAllSelectVehicles();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}
                {"  "}

                <Select
                  maxTagCount="responsive"
                  className="searchInput"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 150 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option key={val.vehicleId} value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>

                <Select
                  // placeholder="Pickup"
                  placeholder={this.context.translate("_PICKuP_")}
                  style={{ width: 100 }}
                  className="searchInput"
                  onChange={(val) => {
                    this.setState({ pickupFilter: val })
                  }}
                >
                  <Select.Option value="All">
                    {this.context.translate("_ALL_")}
                  </Select.Option>
                  <Select.Option value="Pickup">
                    {this.context.translate("_PICKuP_")}
                  </Select.Option>
                  <Select.Option value="Drop">
                    {this.context.translate("_DROP_")}
                  </Select.Option>
                </Select>

                <Select
                  style={{ width: 150 }}
                  className="searchInput"
                  status={this.state.Nottype ? "error" : false}
                  onSelect={async (value) => {
                    console.log(value);
                    await this.setState({ reportType: value, Nottype: false });
                    // await this.handleSearch()
                  }}
                  onChange={(value) => this.selectTypeofDate(value)}
                  // placeholder="Type"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_NEWPOI_TYPE_"
                  )}
                >

                  <Select.Option value="3">Datewise Report</Select.Option>
                  {/* <Select.Option value="2">Weekly Report</Select.Option> */}
                  <Select.Option value="1">Monthly Report</Select.Option>
                </Select>
                {this.state.dateWiseReport && (
                  <>
                    <DatePicker
                      // defaultValue={dayjs()}
                      value={this.state.fromDateObj}
                      // format={"YYYY-MM-DD"}
                      style={{ width: "150px", borderRadius: "25px" }}
                      // disabledDate={(current) => {
                      //   return current && current > dayjs();
                      // }}
                      status={this.state.Notdate ? "error" : false}
                      onChange={(date) => {
                        if (date === null) {
                          this.setState({ fromDate: "", fromDateObj: null });
                        } else {
                          this.setState({
                            // fromDate: date.format("YYYY-MM-DD"),
                            fromDate: date.format("YYYY-MM-DD"),
                            fromDateObj: date,
                          });
                        }
                      }}
                    // style={{ width: "100%" }}
                    />
                    <DatePicker
                      defaultValue={dayjs()}
                      value={this.state.toDateObj}
                      // format={"YYYY-MM-DD"}
                      style={{ width: "150px", borderRadius: "25px" }}
                      // disabledDate={(current) => {
                      //   return current && current > dayjs();
                      // }}
                      status={this.state.Notdate ? "error" : false}
                      onChange={(date) => {
                        if (date === null) {
                          this.setState({ toDate: "", toDateObj: null });
                        } else {
                          // this.setState({ toDate: date.format("YYYY-MM-DD") });
                          this.setState({
                            toDate: date.format("YYYY-MM-DD"),
                            toDateObj: date,
                          });
                        }
                      }}

                    // style={{ width: "100%" }}
                    />

                  </>
                )}
                {this.state.monthWiseReport && (
                  <>
                    {/* <RangePicker
                      // placeholder={["From Month", "To Month"]}
                      format="MM-YYYY"
                      picker="month"
                      style={{ borderRadius: "25px", width: "200px" }}
                      onChange={(val) => {
                        this.onDateTimeChange(val);
                      }}
                      // disabledDate={(current) => {
                      //   return current && current > dayjs();
                      // }}
                      status={this.state.Notdate ? "error" : false}
                      showTime={{
                        format: "h:mmA",
                        defaultValue: [
                          dayjs().startOf("day"),
                          dayjs().endOf("day"),
                        ],
                      }}
                      defaultValue={[
                        dayjs().startOf("day"),
                        dayjs().endOf("day"),
                      ]}
                    /> */}
                    <RangePicker
                      format="MM-YYYY"
                      picker="month"
                      style={{ borderRadius: "25px", width: "200px" }}
                      value={this.state.monthRange}
                      status={this.state.Notdate ? "error" : false}
                      onChange={(val) => {
                        if (!val) {
                          this.setState({
                            monthRange: [],
                            fromDate: "",
                            toDate: "",
                          });
                        } else {
                          this.setState({
                            monthRange: val,
                            fromDate: val[0].startOf("month").format("YYYY-MM-DD"),
                            toDate: val[1].endOf("month").format("YYYY-MM-DD"),
                          });
                        }
                      }}
                    />
                  </>
                )}

                <Input style={{ width: 190, borderRadius: 25 }}
                  placeholder="Search By Student Name"
                  onChange={(e) => { this.setState({ searchStudent: e.target.value }); this.handleSearchStudent(e.target.value) }} />

                <Button type="primary" onClick={() => this.showData()}>
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.passengerLogReportStore?.passengers?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            rowKey="passengerId"
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            key={this.state.selectedColumns.length}
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.passengerLogReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.passengerLogReportStore?.passengers}
            loading={this.passengerLogReportStore?.loading}
            onChange={this.handleTableChange}
            scroll={{
              // y: this.state.clientHeight-240,
              x: 100,
            }}
          />

          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
        </div>
      </>
    );
  }
}
PassengerLogReportList.contextType = StoreContext;
export default observer(withRouter(PassengerLogReportList));
